import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=0817fa04&scoped=true&"
import script from "./NotificationSetting.vue?vue&type=script&lang=js&"
export * from "./NotificationSetting.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=0817fa04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0817fa04",
  null
  
)

export default component.exports